const businessTypeOptions: { [key: string]: string } = {
  'Sole Trader': 'Individual or sole proprietorship',
  Corporation: 'Corporation',
  'Registered Charity': 'Associations, Charities and Not for Profits',
  'Incorporated Partnership': 'Partnership',
  'Public Limited Company': 'Public Limited Company',
  Other: 'Other',
};

export default businessTypeOptions;
